<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      :data="activities"
      v-loading="listLoading"
      style="width: 100%"
      ref="table"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      class="custom-tbl"
    >
      <el-table-column type="selection" min-width="5"> </el-table-column>
      <el-table-column type="index" label="序号" min-width="5">
      </el-table-column>
      <el-table-column
        prop="title"
        label="活动标题"
        min-width="20"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag
            v-if="
              scope.row.isMemUnapprove && hasButtonRight('handleMemberApprove')
            "
            size="mini"
            effect="dark"
            type="danger"
            class="new-member"
          >预约待审</el-tag>
            <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="地址"
        min-width="20"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="promoter"
        label="发起人"
        min-width="10"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="startTime"
        label="活动时间"
        min-width="20"
        show-overflow-tooltip
        :formatter="formatStartTime"
      ></el-table-column>
      <el-table-column
        prop="deadline"
        label="报名截止时间"
        min-width="10"
        show-overflow-tooltip
        :formatter="formatDeadline"
      ></el-table-column>
      <el-table-column
        prop="state"
        label="活动状态"
        min-width="10"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state == 'Draft'" type="info">草稿</el-tag>
          <el-tag v-if="scope.row.state == 'Unapproved'" type="primary"
            >待审核</el-tag
          >
          <el-tag v-if="scope.row.state == 'Approving'" type="primary"
            >审核中</el-tag
          >
          <el-tag v-if="scope.row.state == 'Approved'" type="success"
            >已审核</el-tag
          >
          <el-tag v-if="scope.row.state == 'Rejected'" type="danger"
            >已驳回</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="20">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-if="false && canFavorite(scope.row)"
            @click="handleFavorite(scope.row)"
            >收藏</el-button
          >
          <el-button
            size="mini"
            v-if="false && canUnFavorite(scope.row)"
            @click="handleUnFavorite(scope.row)"
            >取消收藏</el-button
          >
          <el-button
            size="mini"
            v-if="canRemind(scope.row)"
            @click="handleRemind(scope.row)"
            >提醒</el-button
          >
          <el-button
            size="mini"
            v-if="canUnRemind(scope.row)"
            @click="handleUnRemind(scope.row)"
            >取消提醒</el-button
          >
          <el-button
            size="mini"
            v-if="canSignIn(scope.row)"
            @click="handleSignIn(scope.row)"
            >签到</el-button
          >
          <el-button
            size="mini"
            v-if="canTakePart(scope.row)"
            @click="handleTakePart(scope.row)"
            >预约</el-button
          >
          <el-button
            size="mini"
            v-if="canGiveUp(scope.row)"
            @click="handleGiveUp(scope.row)"
            >取消预约</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        style="float: right"
        :current-page="pageModel.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageModel.pageSize"
        :total="pageModel.dataCount"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="活动标题" prop="title">
              <el-input v-model="editForm.title" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动类型" prop="typeId">
              <el-select
                v-model="editForm.typeId"
                clearable
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in activityType"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开始时间" prop="startTime">
              <el-date-picker
                type="datetime"
                v-model="editForm.startTime"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker
                type="datetime"
                v-model="editForm.endTime"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发起人" prop="promoterId">
              <UsersSelect
                v-model="editForm.promoterUser"
                style="width: 100%"
                :queryplace="
                  editForm.promoter ? editForm.promoter : '请选择人员'
                "
                @input="promoterSelected"
              ></UsersSelect>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报名截止" prop="deadline">
              <el-date-picker
                type="datetime"
                v-model="editForm.deadline"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="关联场馆" prop="relateVenue">
              <el-switch
                v-model="relateVenue"
                name="relateVenue"
                :active-value="true"
                :inactive-value="false"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参与人数" prop="maxPeople">
              <el-input
                v-model.number="editForm.maxPeople"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="活动地址" prop="address">
              <VenueSelect
                v-show="relateVenue"
                v-model="editForm.venue"
                style="width: 100%"
                :queryplace="editForm.address"
                @input="venueSelected"
              >
              </VenueSelect>
              <el-input
                v-show="!relateVenue"
                v-model="editForm.address"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="活动简介" prop="description">
              <el-input
                type="textarea"
                v-model="editForm.description"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="多场次" prop="hasMultiSessions">
              <el-switch
                v-model="editForm.hasMultiSessions"
                name="hasMultiSessions"
                :active-value="true"
                :inactive-value="false"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动积分" prop="integral">
              <el-input
                v-model.number="editForm.integral"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-show="editForm.hasMultiSessions">
            <el-form-item label="场次" prop="multiSessions">
              <DynamicSessionTags
                :tags="editForm.multiSessions"
                @dynamictagsInput="multiSessionsInput"
              ></DynamicSessionTags>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="标签" prop="tags" size="mini">
              <DynamicTags
                :tags="editForm.tags"
                @dynamictagsInput="dynamictagsInput"
              ></DynamicTags>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="封面" prop="coverImage">
              <ImageFile
                tips="推荐尺寸16:9,大小不超过1MB"
                :value="coverImageList"
                :limitCount="1"
                :limitSize="1024"
                @change="coverImageChange"
              ></ImageFile>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="宣传图" prop="contentImage">
              <ImageFile
                tips="推荐尺寸16:9,每张大小不超过1MB,最多允许上传4张"
                :value="contentImageList"
                :limitCount="4"
                :limitSize="1024"
                @change="contentImageChange"
                :isMultiple="true"
              ></ImageFile>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="100px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="活动标题" prop="title">
              <el-input v-model="addForm.title" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动类型" prop="typeId">
              <el-select
                v-model="addForm.typeId"
                clearable
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in activityType"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开始时间" prop="startTime">
              <el-date-picker
                type="datetime"
                v-model="addForm.startTime"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker
                type="datetime"
                v-model="addForm.endTime"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发起人" prop="promoterId">
              <UsersSelect
                v-model="addForm.promoterUser"
                style="width: 100%"
                queryplace="请选择人员"
                @input="promoterSelected"
              ></UsersSelect>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报名截止" prop="deadline">
              <el-date-picker
                type="datetime"
                v-model="addForm.deadline"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="关联场馆" prop="relateVenue">
              <el-switch
                v-model="relateVenue"
                :active-value="true"
                :inactive-value="false"
                name="relateVenue"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参与人数" prop="maxPeople">
              <el-input
                v-model.number="addForm.maxPeople"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="活动地址" prop="address">
              <VenueSelect
                v-show="relateVenue"
                v-model="addForm.venue"
                style="width: 100%"
                queryplace="请选择场馆"
                @input="venueSelected"
              >
              </VenueSelect>
              <el-input
                v-show="!relateVenue"
                v-model="addForm.address"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="活动简介" prop="description">
              <el-input
                type="textarea"
                v-model="addForm.description"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="多场次" prop="hasMultiSessions">
              <el-switch
                v-model="addForm.hasMultiSessions"
                :active-value="true"
                :inactive-value="false"
                name="hasMultiSessions"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动积分" prop="integral">
              <el-input
                v-model.number="addForm.integral"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-show="addForm.hasMultiSessions">
            <el-form-item label="场次" prop="multiSessions">
              <DynamicSessionTags
                :tags="addForm.multiSessions"
                @dynamictagsInput="multiSessionsInput"
              ></DynamicSessionTags>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="标签" prop="tags" size="mini">
              <DynamicTags
                :tags="addForm.tags"
                @dynamictagsInput="dynamictagsInput"
              ></DynamicTags>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="封面" prop="coverImage">
              <ImageFile
                tips="推荐尺寸16:9,大小不超过1MB"
                :value="coverImageList"
                :limitCount="1"
                :limitSize="1024"
                @change="coverImageChange"
              ></ImageFile>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="宣传图" prop="contentImage">
              <ImageFile
                tips="推荐尺寸16:9,每张大小不超过1MB,最多允许上传4张"
                :value="contentImageList"
                :limitCount="4"
                :limitSize="1024"
                @change="contentImageChange"
                :isMultiple="true"
              ></ImageFile>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="志愿人数" prop="volunteerCount">
              <el-input
                v-model.number="addForm.volunteerCount"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="志愿要求" prop="volunteerRequirement">
              <el-input
                type="textarea"
                v-model="addForm.volunteerRequirement"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--预约-->
    <el-dialog
      title="预约"
      :visible.sync="takePartFormVisible"
      v-model="takePartFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="takePartForm"
        v-if="currentRow"
        label-width="100px"
        :rules="takePartFormRules"
        ref="takePartForm"
      >
        <el-row v-if="currentRow.hasMultiSessions">
          <el-col :span="24">
            <el-form-item label="活动场次" prop="sessionId">
              <el-select
                v-model="takePartForm.sessionId"
                clearable
                placeholder="请选择"
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in currentRow.multiSessions"
                  :key="index"
                  :label="item.startTime"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="预约数量" prop="userCount">
              <el-input-number
                size="mini"
                v-model="takePartForm.userCount"
                :step="1"
                :min="1"
                step-strictly
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="姓名" prop="name">
              <el-input size="mini" v-model="takePartForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="联系电话" prop="tel">
              <el-input size="mini" v-model="takePartForm.tel"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input size="mini" v-model="takePartForm.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="takePartFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="takePartSubmit"
          :loading="takePartLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!-- 审核 -->
    <el-dialog
      title="活动审核"
      :visible.sync="approveFormVisible"
      v-model="approveFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="approveForm"
        v-if="currentRow"
        label-width="100px"
        :rules="approveFormRules"
        ref="approveForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="审核状态" prop="state">
              <el-radio-group v-model="approveForm.state">
                <el-radio :label="1">待审核</el-radio>
                <el-radio :label="2">审核中</el-radio>
                <el-radio :label="3">审核通过</el-radio>
                <el-radio :label="-3">驳回</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="意见备注" prop="remark">
              <el-input size="mini" v-model="approveForm.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="approveFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="approveSubmit"
          :loading="approveLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <el-drawer
      :title="'“' + (currentRow ? currentRow.title : '') + '”的预约审核'"
      size="60%"
      :visible.sync="activityMemberApproveDrawerVisible"
      direction="rtl"
    >
      <ActivityMemberApprove
        ref="activityMemberApprove"
        :data="currentRow"
        @memberApproveSuccess="handleQuery"
      ></ActivityMemberApprove>
    </el-drawer>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  queryActivityListPage,
  removeActivity,
  saveActivity,
  getChildDictionary,
  takePartActivity,
  giveUpActivity,
  signInActivity,
  removeFavorites,
  saveFavorites,
  removeUserNotes,
  saveUserNotes,
  approveActivity,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import ImageFile from "../../components/ImageFile";
import UsersSelect from "../../components/UserSelect";
import VenueSelect from "../../components/VenueSelect";
import DynamicTags from "../../components/DynamicTags";
import DynamicSessionTags from "../../components/DynamicSessionTags";
import ActivityMemberApprove from "./ActivityMemberApprove";
import { DictEnum, FavoritesTypeEnum, ActivityStateEnum } from "../../api/enum";

export default {
  components: {
    Toolbar,
    ImageFile,
    UsersSelect,
    VenueSelect,
    DynamicTags,
    DynamicSessionTags,
    ActivityMemberApprove,
  },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filter: {
        key: "",
      },
      activities: [],
      pageModel: {
        pageSize: 10,
        dataCount: 0,
        page: 0,
        pageCount: 0,
      },
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        title: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { max: 100, message: "活动名称不能超过100个字符", trigger: "blur" },
        ],
        typeId: [
          { required: true, message: "请选择活动类型", trigger: "blur" },
        ],
        promoterId: [
          { required: true, message: "请选择发起人", trigger: "blur" },
        ],
        startTime: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "blur",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: "blur",
          },
        ],
        deadline: [
          {
            required: true,
            message: "请选择报名截止时间",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请输入或选择活动地址", trigger: "blur" },
          { max: 500, message: "活动地址不能超过500个字符", trigger: "blur" },
        ],
        description: [
          { required: true, message: "请输入活动简介", trigger: "blur" },
          { max: 500, message: "活动简介不能超过500个字符", trigger: "blur" },
        ],
        maxPeople: [
          { required: true, message: "请输入参与人数", trigger: "blur" },
          { type: "number", message: "参与人数必须为数字", trigger: "blur" },
        ],
        integral: [
          { required: true, message: "请输入活动积分", trigger: "blur" },
          { type: "number", message: "活动积分必须为数字", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        id: "",
        title: "",
        typeId: "",
        startTime: "",
        endTime: "",
        promoterUser: {
          uID: "",
        },
        promoter: "",
        promoterId: "",
        deadline: "",
        address: "",
        description: "",
        maxPeople: 20,
        tags: "",
        hasMultiSessions: false,
        multiSessions: [],
        integral: 0,
      },
      relateVenue: false,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        title: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { max: 100, message: "活动名称不能超过100个字符", trigger: "blur" },
        ],
        typeId: [
          { required: true, message: "请选择活动类型", trigger: "blur" },
        ],
        promoterId: [
          { required: true, message: "请选择发起人", trigger: "blur" },
        ],
        startTime: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "blur",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: "blur",
          },
        ],
        deadline: [
          {
            required: true,
            message: "请选择报名截止时间",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请输入或选择活动地址", trigger: "blur" },
          { max: 500, message: "活动地址不能超过500个字符", trigger: "blur" },
        ],
        description: [
          { required: true, message: "请输入活动简介", trigger: "blur" },
          { max: 500, message: "活动简介不能超过500个字符", trigger: "blur" },
        ],
        maxPeople: [
          { required: true, message: "请输入参与人数", trigger: "blur" },
          { type: "number", message: "参与人数必须为数字", trigger: "blur" },
        ],
        integral: [
          { required: true, message: "请输入活动积分", trigger: "blur" },
          { type: "number", message: "活动积分必须为数字", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        title: "",
        typeId: "",
        startTime: "",
        endTime: "",
        promoterUser: {
          uID: "",
        },
        promoter: "",
        promoterId: "",
        deadline: "",
        address: "",
        description: "",
        maxPeople: 20,
        tags: "",
        hasMultiSessions: false,
        multiSessions: [],
        integral: 0,
      },
      coverImageList: [],
      contentImageList: [],
      activityType: [],

      takePartFormVisible: false,
      takePartLoading: false,
      takePartForm: {
        sessionId: "",
        userCount: 1,
        name: "",
        tel: "",
        remark: "",
      },
      takePartFormRules: {
        userCount: [
          { required: true, message: "预约数量不能为空", trigger: "blur" },
          {
            min: 1,
            type: "number",
            message: "预约数量不能小于1",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "姓名不能为空", trigger: "blur" },
          { max: 50, message: "姓名最长不能超过50个字符", trigger: "blur" },
        ],
        tel: [
          { required: true, message: "联系电话不能为空", trigger: "blur" },
          { max: 50, message: "联系电话最长不能超过50个字符", trigger: "blur" },
        ],
        remark: [
          { max: 200, message: "备注最长不能超过200个字符", trigger: "blur" },
        ],
      },
      approveFormVisible: false,
      approveLoading: false,
      approveForm: {
        state: ActivityStateEnum.Unapproved,
        remark: "",
      },
      approveFormRules: {
        state: [
          { required: true, message: "审核状态不能为空", trigger: "blur" },
        ],
        remark: [
          { max: 200, message: "备注最长不能超过200个字符", trigger: "blur" },
        ],
      },
      activityMemberApproveDrawerVisible: false,
    };
  },
  methods: {
    coverImageChange() {},
    contentImageChange() {},
    handleMemberApprove() {
      if (this.currentRow) {
        if (this.currentRow.isMemUnapprove) {
          this.activityMemberApproveDrawerVisible = true;
          this.$nextTick(() => {
            this.$refs["activityMemberApprove"].getActivityDetail();
          });
        } else {
          this.$notify({ message: "该活动暂无预约待审信息", type: "error" });
        }
      } else {
        this.$notify({ message: "请先选择要审核的行", type: "error" });
      }
    },
    handleApprove() {
      if (this.currentRow) {
        this.approveForm.id = this.currentRow.id;
        this.approveForm.state = ActivityStateEnum[this.currentRow.state];
        this.approveFormVisible = true;
      }
    },
    approveSubmit() {
      this.$confirm("确认提交审核状态吗？", "提示", {}).then(() => {
        this.approveLoading = true;
        approveActivity(this.approveForm).then((res) => {
          if (res.data.isSuccess) {
            this.$notify({ message: "提交成功", type: "success" });
            this.approveFormVisible = false;
            this.$refs["approveForm"].resetFields();
            this.handleQuery();
          } else {
            this.$notify({ message: res.data.msg, type: "error" });
          }
          this.approveLoading = false;
        });
      });
    },
    canFavorite(row) {
      return row.favorite == null;
    },
    handleFavorite(row) {
      if (row.favorite == null) {
        let favorite = {
          objType: FavoritesTypeEnum.Activity,
          objId: row.id,
        };
        let formData = new FormData();
        formData.append("model", JSON.stringify(favorite));
        saveFavorites(formData).then((res) => {
          if (res.data.isSuccess) {
            this.$notify({ message: "收藏成功", type: "success" });
            this.handleQuery();
          } else {
            this.$notify({ message: res.data.msg, type: "error" });
          }
        });
      } else {
        this.$notify({
          message: "已收藏过，请勿重复收藏",
          type: "warning",
        });
      }
    },
    canUnFavorite(row) {
      return row && row.favorite && row.favorite.id > 0;
    },
    handleUnFavorite(row) {
      if (row && row.favorite && row.favorite.id > 0) {
        let favorite = {
          id: row.favorite.id,
        };
        removeFavorites(favorite).then((res) => {
          if (res.data.isSuccess) {
            this.$notify({ message: "取消收藏成功", type: "success" });
            this.handleQuery();
          } else {
            this.$notify({ message: res.data.msg, type: "error" });
          }
        });
      } else {
        this.$notify({
          message: "当前未收藏",
          type: "warning",
        });
      }
    },
    canRemind(row) {
      return row.notes == null;
    },
    handleRemind(row) {
      if (row && row.notes == null) {
        let notes = {
          objType: FavoritesTypeEnum.Activity,
          objId: row.id,
          description: "活动提醒：" + row.title,
        };
        let formData = new FormData();
        formData.append("model", JSON.stringify(notes));
        saveUserNotes(formData).then((res) => {
          if (res.data.isSuccess) {
            this.$notify({ message: "开启提醒成功", type: "success" });
            this.handleQuery();
          } else {
            this.$notify({ message: res.data.msg, type: "error" });
          }
        });
      } else {
        this.$notify({
          message: "已开启提醒，请勿重复开启",
          type: "warning",
        });
      }
    },
    canUnRemind(row) {
      return row && row.notes && row.notes.id > 0;
    },
    handleUnRemind(row) {
      if (row && row.notes && row.notes.id > 0) {
        let notes = {
          id: row.notes.id,
        };
        removeUserNotes(notes).then((res) => {
          if (res.data.isSuccess) {
            this.$notify({ message: "取消提醒成功", type: "success" });
            this.handleQuery();
          } else {
            this.$notify({ message: res.data.msg, type: "error" });
          }
        });
      } else {
        this.$notify({
          message: "当前未开启提醒",
          type: "warning",
        });
      }
    },
    canSignIn(row) {
      return row && row.canSignIn;
    },
    handleSignIn(row) {
      this.currentRow = row;
      let user = this.getCurrentUser();
      if (user != null && row && row.members) {
        var exist = row.members.find((x) => x.userId == user.uID);
        if (exist) {
          if (exist.isSignIn) {
            this.$notify({
              message: "已签到过，请勿重复签到",
              type: "warning",
            });
            return;
          }
          signInActivity(exist).then((res) => {
            if (res.data.isSuccess) {
              this.$notify({ message: "签到成功", type: "success" });
              this.handleQuery();
            } else {
              this.$notify({ message: res.data.msg, type: "error" });
            }
          });
        }
      }
    },
    canTakePart(row) {
      return row && row.canTakePart;
    },
    handleTakePart(row) {
      this.currentRow = row;
      let user = this.getCurrentUser();
      if (user != null && row && row.members) {
        var exist = row.members.find((x) => x.userId == user.uID);
        if (!exist) {
          if (this.currentRow.hasMultiSessions) {
            this.takePartFormRules["sessionId"] = [
              { required: true, message: "场次不能为空", trigger: "blur" },
            ];
          } else {
            this.takePartFormRules["sessionId"] = [];
          }
          this.takePartFormVisible = true;
          this.takePartForm = {
            sessionId: "",
            userCount: 1,
            name: user.uRealName,
            tel: user.tel,
            remark: "",
          };
        }
      }
    },
    takePartSubmit() {
      let user = this.getCurrentUser();
      this.takePartForm.activityId = this.currentRow.id;
      this.takePartForm.userId = user.uID;
      this.$refs.takePartForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.takePartLoading = true;
            takePartActivity(this.takePartForm).then((res) => {
              if (res.data.isSuccess) {
                this.$notify({ message: "预约成功", type: "success" });
                this.$refs["takePartForm"].resetFields();
                this.takePartFormVisible = false;
                this.handleQuery();
              } else {
                this.$notify({ message: res.data.msg, type: "error" });
              }
              this.takePartLoading = false;
            });
          });
        }
      });
    },
    canGiveUp(row) {
      return row && row.hadTakePart && !row.hadSignIn;
    },
    handleGiveUp(row) {
      this.currentRow = row;
      let user = this.getCurrentUser();
      this.$confirm("确认取消吗？", "提示", {}).then(() => {
        let param = {
          activityId: this.currentRow.id,
          userId: user.uID,
          remark: "取消预约",
        };
        giveUpActivity(param).then((res) => {
          if (res.data.isSuccess) {
            this.$notify({ message: "取消预约成功", type: "success" });
            this.handleQuery();
          } else {
            this.$notify({ message: res.data.msg, type: "error" });
          }
        });
      });
    },
    dynamictagsInput(tags) {
      if (this.addFormVisible) {
        this.addForm.tags = tags.join("、");
      } else if (this.editFormVisible) {
        this.editForm.tags = tags.join("、");
      }
    },
    multiSessionsInput(sessions) {
      if (this.addFormVisible) {
        this.addForm.multiSessions = sessions;
      } else if (this.editFormVisible) {
        this.editForm.multiSessions = sessions;
      }
    },
    promoterSelected(user) {
      if (this.addFormVisible && user) {
        this.addForm.promoterUser = user;
        this.addForm.promoterId = user.uID;
        this.addForm.promoter = user.uRealName;
      } else if (this.editFormVisible && user) {
        this.editForm.promoterUser = user;
        this.editForm.promoterId = user.uID;
        this.editForm.promoter = user.uRealName;
      }
    },
    venueSelected(venue) {
      if (this.addFormVisible && venue) {
        this.addForm.address = venue.address;
        if (venue.id) {
          this.addForm.venueId = venue.id;
        }
      } else if (this.editFormVisible && venue) {
        this.editForm.address = venue.address;
        if (venue.id) {
          this.editForm.venueId = venue.id;
        }
      }
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filter.key = item.search;
      this[item.func].apply(this, item);
    },
    formatEnabled: function (row) {
      return row.enabled ? "正常" : "停止";
    },
    formatDeadline: function (row) {
      return util.formatDate.format(new Date(row.deadline), "MM-dd hh:mm");
    },
    formatStartTime: function (row) {
      let startTime = util.formatDate.format(
        new Date(row.startTime),
        "MM-dd hh:mm"
      );
      let endTime = util.formatDate.format(
        new Date(row.endTime),
        "MM-dd hh:mm"
      );
      return startTime + " ~ " + endTime;
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.handleQuery();
    },
    handleSizeChange(val) {
      this.filter.page = 1;
      this.filter.pageSize = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      this.listLoading = true;

      //NProgress.start();
      queryActivityListPage(this.filter).then((res) => {
        this.activities = res.data.response.data;
        this.pageModel = res.data.response;
        this.pageModel.data = null;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.id };
          removeActivity(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.isSuccess) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      this.coverImageList = [];
      this.contentImageList = [];
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      if (row.coverImage) {
        this.coverImageList.push(row.coverImage);
      }
      if (row.contentImage) {
        this.contentImageList = row.contentImage;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.relateVenue =
        this.editForm.venueId != null && this.editForm.venueId.length > 0;
      if (this.relateVenue) {
        this.editForm.venue = {
          id: this.editForm.venueId,
          address: this.editForm.address,
        };
      }
    },
    //显示新增界面
    handleAdd() {
      this.coverImageList = [];
      this.contentImageList = [];
      this.addFormVisible = true;
      let curUser = this.getCurrentUser();
      this.addForm = {
        title: "",
        typeId: "",
        startTime: "",
        endTime: "",
        promoterUser: curUser,
        promoter: curUser.uRealName,
        promoterId: curUser.uID,
        deadline: "",
        address: "",
        description: "",
        maxPeople: 20,
        tags: "",
        hasMultiSessions: false,
        integral: 20,
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            this.editForm.venue = null;
            this.editForm.promoterUser = null;
            let formData = new FormData();
            formData.append("model", JSON.stringify(this.editForm));
            let covers = this.coverImageList.filter((s) => s.status == "ready");
            if (covers.length > 0) {
              formData.append("coverImage", covers[0].raw);
            }
            let contents = this.contentImageList.filter(
              (s) => s.status == "ready"
            );
            if (contents.length > 0) {
              contents.forEach((element) => {
                formData.append("contentImages", element.raw);
              });
            }
            saveActivity(formData).then((res) => {
              this.editLoading = false;
              if (res.data.isSuccess) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.coverImageList = [];
                this.contentImageList = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      if (_this.addForm.volunteerCount > 0) {
        _this.addFormRules.volunteerRequirement = [
          { required: true, message: "请输入志愿要求", trigger: "blur" },
          { max: 500, message: "志愿要求不能超过500个字符", trigger: "blur" },
        ];
      } else {
        _this.addFormRules.volunteerRequirement = [];
      }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            this.addForm.venue = null;
            this.addForm.promoterUser = null;
            let formData = new FormData();
            formData.append("model", JSON.stringify(this.addForm));
            let covers = this.coverImageList.filter((s) => s.status == "ready");
            if (covers.length > 0) {
              formData.append("coverImage", covers[0].raw);
            }
            let contents = this.contentImageList.filter(
              (s) => s.status == "ready"
            );
            if (contents.length > 0) {
              contents.forEach((element) => {
                formData.append("contentImages", element.raw);
              });
            }
            saveActivity(formData).then((res) => {
              this.addLoading = false;
              if (res.data.isSuccess) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.coverImageList = [];
                this.contentImageList = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    initActivityType() {
      getChildDictionary({ code: DictEnum.ActivityType }).then((res) => {
        if (res.data.isSuccess) {
          this.activityType = res.data.response;
        }
      });
    },
    hasButtonRight(func) {
      let button = this.buttonList.find((x) => x.func == func);
      return button != null;
    },
  },
  mounted() {
    this.handleQuery();
    this.initActivityType();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.custom-tbl /deep/ .new-member {
  font-size: 8px;
  padding: 0;
}
</style>